// import React, { useState, useEffect, useCallback } from 'react';
// import {
//   Button,
//   Container,
//   Dialog,
//   Grid,
//   Paper,
//   Stack,
//   Typography,
//   FormControl,
//   InputLabel,
//   MenuItem,
//   Select,
//   Chip,
//   Checkbox
// } from '@mui/material';
// import { FormProvider, TextField } from '../../../../../components';
// import { useForm, Controller } from 'react-hook-form';
// import { yupResolver } from '@hookform/resolvers/yup';
// import * as Yup from 'yup';
// import { dropdownFetch, request, toast } from '../../../../../utils';
// import { useLocation } from 'react-router-dom';
// import { DuePaymentRegisterReportPdf } from '../../../../Print/options/Hospital/HMS';

// export const OpdPatientVitalsReport = () => {
//   const { pathname } = useLocation();
//   const [departmentDataObj, setDepartmentObj] = useState({ loading: true, data: [] });
//   const [departmentDropDown, setDepartmentDropDown] = useState([]);
//   const [openPrint, setOpenPrint] = useState(false);
//   const [dropdownOpen, setDropdownOpen] = useState(false);
//   const methods = useForm({
//     resolver: yupResolver(
//       Yup.object().shape({
//         from_date: Yup.string().required(' '),
//         to_date: Yup.string().required(' ')
//       })
//     ),
//     defaultValues: {
//       from_date: '',
//       to_date: ''
//     },
//     mode: 'all'
//   });

//   const { handleSubmit, watch, control } = methods;

//   const getDepartmentDropdown = useCallback(async () => {
//     try {
//       const data = await dropdownFetch('department');
//       setDepartmentDropDown([{ _id: 'selectAll', name: 'Select All' }, ...data]);
//     } catch (error) {
//       console.error('Error fetching Department data:', error);
//     }
//   }, []);

//   useEffect(() => {
//     getDepartmentDropdown();
//   }, [getDepartmentDropdown]);

//   const handleSelectAll = (event) => {
//     const isSelected = event.target.checked;
//     const allDepartmentNames = departmentDropDown
//       .filter((option) => option._id !== 'selectAll')
//       .map((option) => option.name);
//     methods.setValue('sponsor', isSelected ? allDepartmentNames : [], { shouldValidate: true, shouldDirty: true });
//     setDropdownOpen(true);
//   };
//   const MultiSelectDropdown = () => {
//     const selectedValues = watch('department');

//     return (
//       <FormControl fullWidth sx={{ mt: 1, ml: 15 }}>
//         <InputLabel style={{ fontSize: '10px', color: 'black', fontWeight: 'bolder' }}>Department</InputLabel>
//         <Controller
//           name="department"
//           control={control}
//           render={({ field }) => (
//             <Select
//               multiple
//               value={field.value}
//               open={dropdownOpen}
//               onOpen={() => setDropdownOpen(true)}
//               onClose={() => setDropdownOpen(false)}
//               onChange={(event) => {
//                 field.onChange(event.target.value);
//                 setDropdownOpen(true);
//               }}
//               style={{ width: '79%', padding: 0 }}
//               renderValue={(selected) => (
//                 <div style={{ display: 'flex', flexWrap: 'wrap', padding: 0 }}>
//                   {selected.map((value) => (
//                     <Chip key={value} label={value} />
//                   ))}
//                 </div>
//               )}
//               sx={{
//                 padding: '8px',
//                 width: '200px'
//               }}
//             >
//               <MenuItem key="selectAll">
//                 <Checkbox
//                   checked={selectedValues.length === departmentDropDown.length - 1}
//                   indeterminate={selectedValues.length > 0 && selectedValues.length < departmentDropDown.length - 1}
//                   onChange={handleSelectAll}
//                 />
//                 <Typography>Select All</Typography>
//               </MenuItem>
//               {departmentDropDown.map(
//                 (option) =>
//                   option._id !== 'selectAll' && (
//                     <MenuItem key={option._id} value={option.department}>
//                       <Checkbox checked={selectedValues.indexOf(option.department) > -1} />
//                       <Typography>{option.department}</Typography>
//                     </MenuItem>
//                   )
//               )}
//             </Select>
//           )}
//         />
//       </FormControl>
//     );
//   };

//   return (
//     <>
//       <Paper
//         sx={{
//           p: 0,
//           flex: 1,
//           borderRadius: 0,
//           boxShadow: 'none'
//         }}
//       >
//         <Container
//           sx={{
//             mt: 2,
//             p: 0.2,
//             border: '1px solid',
//             borderColor: 'grey.300',
//             borderRadius: 1
//           }}
//         >
//           <FormProvider methods={methods}>
//             <Stack
//               direction="row"
//               spacing={2}
//               justifyContent="space-between"
//               alignItems="center"
//               sx={{
//                 pb: 0.5,
//                 mb: 3,
//                 borderBottom: '1px solid',
//                 borderColor: 'grey.300'
//               }}
//             >
//               <Typography color="primary" variant="h3">
//                 Opd Patient Vitals Report
//               </Typography>
//               <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
//                 <Button
//                   variant="contained"
//                   disabled={!watch('department')}
//                   onClick={() =>
//                     window.open(
//                       `/print${pathname}?refId=${JSON.stringify({
//                         department: watch('department'),
//                         from_date: watch('from_date'),
//                         to_date: watch('to_date')
//                       })}`,
//                       '_blank'
//                     )
//                   }
//                 >
//                   View Report
//                 </Button>
//                 <Button variant="contained">Exit</Button>
//               </Stack>
//             </Stack>
//             <Grid container spacing={2}>
//               <Grid item xs={6} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
//                 <Stack spacing={0.5} direction="row" alignItems="center">
//                   <Typography sx={{ flex: 0.2 }}>From Date</Typography>
//                   <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
//                 </Stack>
//                 <Stack spacing={0.5} direction="row" alignItems="center">
//                   <Typography sx={{ flex: 0.2 }}>To Date</Typography>
//                   <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
//                 </Stack>
//                 <MultiSelectDropdown />
//               </Grid>
//             </Grid>
//           </FormProvider>
//         </Container>
//       </Paper>
//       <Dialog
//         open={openPrint}
//         onClose={() => setOpenPrint(false)}
//         PaperProps={{ sx: { width: '80%', height: '85%', p: 2 } }}
//         maxWidth="xl"
//         scroll="body"
//       ></Dialog>
//     </>
//   );
// };

import React, { useState, useEffect, useCallback } from 'react';
import {
  Button,
  Chip,
  Container,
  Dialog,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Typography,
  Checkbox
} from '@mui/material';
import { FormProvider, TextField } from '../../../../../components';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { DuePaymentRegisterReportPdf } from '../../../../Print/options/Hospital/HMS';

export const OpdPatientVitalsReport = () => {
  const { pathname } = useLocation();
  const [departmentDropdown, setDepartmentdown] = useState([]);
  const [openPrint, setOpenPrint] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const schema = Yup.object().shape({
    from_date: Yup.string().required(' '),
    to_date: Yup.string().required(' '),
    department: Yup.array().min(1, ' ')
  });

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      from_date: '',
      to_date: '',
      department: []
    },
    mode: 'all'
  });

  const { watch, control, setValue } = methods;

  const getDepartmentDropdown = useCallback(async () => {
    try {
      const data = await dropdownFetch('department');
      setDepartmentdown([{ _id: 'selectAll', name: 'Select All' }, ...data]);
      console.log('Hello Department', departmentDropdown);
    } catch (error) {
      console.error('Error fetching department data:', error);
    }
  }, []);

  useEffect(() => {
    getDepartmentDropdown();
  }, [getDepartmentDropdown]);

  const handleSelectAll = (event) => {
    const isSelected = event.target.checked;
    const allDepartmentNames = departmentDropdown
      .filter((option) => option._id !== 'selectAll')
      .map((option) => option.department);
    methods.setValue('department', isSelected ? allDepartmentNames : [], { shouldValidate: true, shouldDirty: true });
    setDropdownOpen(true);
  };

  const MultiSelectDropdown = () => {
    const selectedValues = watch('department');
    return (
      <FormControl fullWidth sx={{ mt: '1%', ml: '21%' }}>
        <InputLabel style={{ fontSize: '10px', color: 'black', fontWeight: 'bolder' }}>Department</InputLabel>
        <Controller
          name="department"
          control={control}
          render={({ field }) => (
            <Select
              multiple
              value={field.value}
              open={dropdownOpen}
              onOpen={() => setDropdownOpen(true)}
              onClose={() => setDropdownOpen(false)}
              onChange={(event) => {
                field.onChange(event.target.value);
                setDropdownOpen(true);
              }}
              style={{ width: '79%', padding: 0 }}
              renderValue={(selected) => (
                <div style={{ display: 'flex', flexWrap: 'wrap', padding: 0 }}>
                  {selected.map((value) => (
                    <Chip key={value} label={value} />
                  ))}
                </div>
              )}
              sx={{
                padding: '8px',
                width: '200px'
              }}
            >
              <MenuItem key="selectAll">
                <Checkbox
                  checked={selectedValues.length === departmentDropdown.length - 1}
                  indeterminate={selectedValues.length > 0 && selectedValues.length < departmentDropdown.length - 1}
                  onChange={handleSelectAll}
                />
                <Typography>Select All</Typography>
              </MenuItem>
              {departmentDropdown.map(
                (option) =>
                  option._id !== 'selectAll' && (
                    <MenuItem key={option._id} value={option.department}>
                      <Checkbox checked={selectedValues.indexOf(option.department) > -1} />
                      <Typography>{option.department}</Typography>
                    </MenuItem>
                  )
              )}
            </Select>
          )}
        />
      </FormControl>
    );
  };

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none'
        }}
      >
        <Container
          sx={{
            mt: 2,
            p: 0.2,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                pb: 0.5,
                mb: 3,
                borderBottom: '1px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Opd Patient Vitals Report
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  disabled={!watch('department').length}
                  onClick={() =>
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({
                        department: watch('department'),
                        from_date: watch('from_date'),
                        to_date: watch('to_date')
                      })}`,
                      '_blank'
                    )
                  }
                >
                  View Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Grid container spacing={2}>
              <Grid item xs={6} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                  <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                  <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                </Stack>
                <MultiSelectDropdown />
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openPrint}
        onClose={() => setOpenPrint(false)}
        PaperProps={{ sx: { width: '80%', height: '85%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      ></Dialog>
    </>
  );
};
